import { render } from "./LeftSideBarContainer.vue?vue&type=template&id=84ca162e"
import script from "./LeftSideBarContainer.vue?vue&type=script&lang=js"
export * from "./LeftSideBarContainer.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__